import serialize from 'serializers/system';
import api from 'services/api';
import action from 'utils/action';
import checkError from 'utils/check-error';

export function systemsGetAll(sorting, filters = {}, filterConfig = {}) {
  const data = {
    ...sorting,
    ...filters,
  };

  return (dispatch) => {
    dispatch(action('SYSTEMS_GET_ALL_REQUEST', { filters: filterConfig, sorting }));

    return new Promise((resolve, reject) => {
      return api.get('/api/systems/search', data).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('SYSTEMS_GET_ALL_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('SYSTEMS_GET_ALL_SUCCESS', payload.json));
          resolve();
        }
      }).catch((payload) => {
        dispatch(action('SYSTEMS_GET_ALL_FAILURE', payload.json));
        reject();
      });
    });
  };
}

export function systemsDetermine(data) {
  return (dispatch) => {
    dispatch(action('SYSTEMS_DETERMINE_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.get('/api/systems/determine', { ...data, products: true }).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('SYSTEMS_DETERMINE_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('SYSTEMS_DETERMINE_SUCCESS', payload.json));
          resolve();
        }
      }).catch((payload) => {
        dispatch(action('SYSTEMS_DETERMINE_FAILURE', payload.json));
        reject();
      });
    });
  };
}

export function systemsCalculateBuffer(data) {
  return (dispatch) => {
    dispatch(action('SYSTEMS_CALCULATE_BUFFER_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.get('/api/systems/buffer-vessel/calculate', { ...data }).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('SYSTEMS_CALCULATE_BUFFER_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('SYSTEMS_CALCULATE_BUFFER_SUCCESS', payload.json));
          resolve(payload.json);
        }
      }).catch((payload) => {
        dispatch(action('SYSTEMS_CALCULATE_BUFFER_FAILURE', payload.json));
        reject();
      });
    });
  };
}

export function systemGet(systemId) {
  return (dispatch) => {
    dispatch(action('SYSTEM_GET_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.get(`/api/systems/${systemId}?products=true`).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('SYSTEM_GET_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('SYSTEM_GET_SUCCESS', serialize(payload.json)));
          resolve(serialize(payload.json));
        }
      }).catch((payload) => {
        dispatch(action('SYSTEM_GET_FAILURE', payload.json));
        reject();
      });
    });
  };
}



// WEBPACK FOOTER //
// ./js/actions/systems.js